<template>
  <b-navbar class="header-alt border-bottom">
  <b-container class="justify-content-center mt-4 mb-4">
    <b-row align-v="center" class="text-center">
      <b-col cols="12" sm="auto">
        <Logo />
      </b-col>
      <b-col>
        <div class="header-alt-title">{{ AppName }}</div>
        <div class="header-alt-subtitle">Team Engagement and Inclusion</div>
      </b-col>
    </b-row>
  </b-container>
</b-navbar>
</template>

<script>
import Logo from '@/assets/images/logo.svg'
import { AppName } from '@/helpers/constants'

export default {
  name: 'HeaderAlt',

  data() {
    return {
      AppName
    }
  },

  components: {
    Logo
  }
}
</script>
